import { COLORS } from '../lib/theme';

export type ConfirmDeleteObjectType = 'border' | 'pin' | 'subArea' | 'forbiddenArea' | 'drive' | 'line' | 'arrow' | 'trail';

const TYPE_LABELS: Record<ConfirmDeleteObjectType, string> = {
  border: 'border',
  pin: 'pin',
  subArea: 'sub-area',
  forbiddenArea: 'forbidden area',
  drive: 'drive',
  line: 'line',
  arrow: 'arrow',
  trail: 'trail',
};

export function ConfirmDeleteModal({
  objectType,
  objectName,
  description,
  onConfirm,
  onCancel,
}: {
  objectType: ConfirmDeleteObjectType;
  objectName?: string;
  /** Overrides the default body text. */
  description?: string;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  const title = objectName
    ? `Delete "${objectName}"?`
    : `Delete this ${TYPE_LABELS[objectType]}?`;

  return (
    <div
      style={{
        position: 'fixed', inset: 0, zIndex: 200,
        background: 'rgba(0,0,0,0.55)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}
    >
      <div
        style={{
          background: COLORS.surface,
          borderRadius: 12,
          padding: '24px',
          maxWidth: 320,
          width: '90%',
          boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
        }}
      >
        <p style={{ margin: '0 0 8px', color: COLORS.onSurface, fontSize: 16, fontWeight: 600 }}>
          {title}
        </p>
        <p style={{ margin: '0 0 20px', color: COLORS.onSurfaceVariant, fontSize: 14 }}>
          {description ?? 'This will permanently remove it from the map.'}
        </p>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button className="wh-btn wh-btn-text" onClick={onCancel}>
            Cancel
          </button>
          <button className="wh-btn wh-btn-danger" onClick={onConfirm}>
            Delete
          </button>
        </div>
      </div>
    </div>
  );
}
